export default __webpack_public_path__ + "static/media/Manrope-SemiBold.c74c847e.woff";